import { faEdit } from "@fortawesome/pro-regular-svg-icons/faEdit";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCreatePublication: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faEdit} />;
};
